/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_Image_InsteadInputs */

const en_us2_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the image`)
};

const pt_br2_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar a imagem`)
};

const es_419_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir la imagen`)
};

const pt_pt2_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar a imagem`)
};

const fr_fr2_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager l'image`)
};

const de_de2_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild teilen`)
};

const it_it2_share_video_image_instead = /** @type {(inputs: Share_Video_Image_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi l'immagine`)
};

/**
* | output |
* | --- |
* | "Share the image" |
*
* @param {Share_Video_Image_InsteadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_image_instead = /** @type {((inputs?: Share_Video_Image_InsteadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_Image_InsteadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_image_instead(inputs)
	if (locale === "es-419") return es_419_share_video_image_instead(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_image_instead(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_image_instead(inputs)
	if (locale === "de-DE") return de_de2_share_video_image_instead(inputs)
	if (locale === "it-IT") return it_it2_share_video_image_instead(inputs)
	return en_us2_share_video_image_instead(inputs)
});
export { share_video_image_instead as "share.video_image_instead" }